import {
  OEButton,
  OEModal,
  OEText,
  OETextInput,
  flex,
  mr,
  mb,
  mt,
} from '@openeducation/oe-it-components';
import { teacherIdAtom } from '@openeducation/oe-it-jotai-atoms';
import { styled } from '@openeducation/oe-it-themes';
import { useAtomValue } from 'jotai';
import { useCallback, useState } from 'react';
import { View } from 'react-native';

import { Banner } from '../../atoms/banner/banner';
import { useRequestAssistance } from '../../hooks/use-request-assistance';
import { useUrlParams } from '../../hooks/use-url-params';

export interface RequestAssistanceFormProps {
  visible: boolean;
  onClose: () => void;
  url?: string;
}
export const RequestAssistanceForm = ({
  visible,
  onClose,
  url,
}: RequestAssistanceFormProps) => {
  const { getParam } = useUrlParams(url?.replace('/classroom?', ''));

  const classroomId = getParam('classroomId');
  const teacherId = useAtomValue(teacherIdAtom);

  const [message, setMessage] = useState('');

  const {
    isRequestAssistanceLoading,
    isRequestAssistanceSuccess,
    requestAssistance,
    requestAssistanceReset,
  } = useRequestAssistance();

  const handleSubmit = async () => {
    if (teacherId && classroomId) {
      await requestAssistance({
        classroomId,
        teacherId,
        notification: message,
      });
    }
  };

  const handleClose = useCallback(() => {
    setMessage('');
    onClose();
    requestAssistanceReset();
  }, [onClose, requestAssistanceReset]);

  return (
    <Modal
      autoDismiss={isRequestAssistanceSuccess}
      showCloseButton
      visible={visible}
      onClose={handleClose}
    >
      <OEText style={mb(12)} fontSize={32} lineHeight={32} fontType="bold">
        Request Assistance
      </OEText>
      {isRequestAssistanceSuccess ? (
        <Banner
          type="success"
          message="Your request for help has been created and sent to the monitors"
        />
      ) : (
        <>
          <OETextInput
            style={[mt(12)]}
            onChangeText={setMessage}
            label="Message"
            value={message}
            mode="outlined"
            numberOfLines={4}
            multiline
            placeholder="Enter your message here..."
          />
          <View style={[flex('flex-row', 'justify-content-end'), mt(12)]}>
            <OEButton type="danger" style={mr(12)} onPress={handleClose}>
              Cancel
            </OEButton>
            <OEButton
              loading={isRequestAssistanceLoading}
              onPress={handleSubmit}
            >
              Send
            </OEButton>
          </View>
        </>
      )}
    </Modal>
  );
};
const Modal = styled(OEModal)`
  width: 600px;
  padding: 40px;
`;
